import { render, staticRenderFns } from "./MoleculeFeedProductsContentModalDuplicate.vue?vue&type=template&id=3bf56f16&"
import script from "./MoleculeFeedProductsContentModalDuplicate.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedProductsContentModalDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports